<template>
  <div class="molecule-feature-card">
    <div class="feature-icon" :style="{ color: iconColor }">
      <vue-feather
        v-if="icon"
        :type="icon"
        :size="iconSize"
        :stroke-width="iconStrokeWidth"
        :stroke="iconColor"
      ></vue-feather>
    </div>
    <h3 class="feature-title">{{ title }}</h3>
    <p class="feature-description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "FeatureCard",
  props: {
    icon: {
      type: String,
      default: null,
    },
    iconSize: {
      type: [Number, String],
      default: 48,
    },
    iconColor: {
      type: String,
      default: "#000",
    },
    iconStrokeWidth: {
      type: [Number, String],
      default: 1.5,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.molecule-feature-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 100%;
}

.feature-icon {
  margin-bottom: 1.5rem;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.feature-title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #000;
  margin: 0 0 1rem 0;
  line-height: 1.3;
}

.feature-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.feature-description:empty {
  display: none;
}

@media (max-width: 768px) {
  .molecule-feature-card {
    width: 100%;
    padding: 1rem;
  }

  .feature-icon {
    margin-bottom: 1.5rem;
  }

  .feature-title {
    font-size: 1.35rem;
    margin-bottom: 1rem;
  }

  .feature-description {
    font-size: 0.95rem;
    width: 100%;
  }
}
</style>
